import styled from "styled-components";

export const InvoiceSummaryBox = styled.div`
  width: 100%;
  max-width: 600px;
  background: #fff;
  border: 1px solid #e9e9e9;
  box-shadow: 0 3px 10px rgba(17, 24, 39, 0.06);
  border-radius: 16px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const SummaryColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => align || "flex-start"};
`;

export const BoxLabel = styled.span`
  font-size: 13px;
  color: #8e8e8e;
`;

export const BoxValue = styled.strong`
  font-size: 24px;
  font-weight: 700;
  color: #B94049;

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const StatusTags = styled.div`
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;

  background: ${({ status }) =>
        status === "PAGO"
            ? "#E6F9F0"
            : status === "ABERTA"
                ? "#FFF4E5"
                : status === "ATRASADA"
                    ? "#FDEAEA"
                    : "#F0F0F0"};

  color: ${({ status }) =>
        status === "PAGO"
            ? "#00A86B"
            : status === "ABERTA"
                ? "#FF8C00"
                : status === "ATRASADA"
                    ? "#E71037"
                    : "#666"};
`;

export const StatusDate = styled.span`
  font-size: 14px;
  color: #6f6f6f;
`;